// extracted by mini-css-extract-plugin
export var standaloneTable = "_g8-0";
export var withExtraHeader = "_g8-1";